function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2238",
  "data-name": "Path 2238",
  d: "M5.155,7.914a7.523,7.523,0,0,0,1.747,4.9L.689,18.982l1.165,1.165,6.165-6.214a7.523,7.523,0,0,0,4.9,1.747A7.478,7.478,0,0,0,18.407,13.4a7.48,7.48,0,0,0,2.282-5.485,7.481,7.481,0,0,0-2.282-5.485A7.481,7.481,0,0,0,12.922.147,7.48,7.48,0,0,0,7.436,2.429,7.478,7.478,0,0,0,5.155,7.914Zm13.981,0a5.986,5.986,0,0,1-1.82,4.393,5.987,5.987,0,0,1-4.393,1.82,5.985,5.985,0,0,1-4.393-1.82A5.985,5.985,0,0,1,6.708,7.914,5.987,5.987,0,0,1,8.529,3.521,5.986,5.986,0,0,1,12.922,1.7a5.987,5.987,0,0,1,4.393,1.82A5.987,5.987,0,0,1,19.136,7.914Zm-6.99-.777H9.815V8.691h2.33v2.33H13.7V8.691h2.33V7.137H13.7V4.807H12.145Z",
  transform: "translate(-0.689 -0.147)",
  fillRule: "evenodd"
});

var SvgZoomWithPlus = function SvgZoomWithPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZoomWithPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-with-plus.117be2c5.svg";
export { ForwardRef as ReactComponent };